module.exports = __webpack_public_path__ + "img/niue.6a1d710.webp";